import { ENVIRONMENTS } from "@consts";

const DEV_SNIPPET_LOCATION = "https://widget-client-dev.hyro.ws/widget.js";
const PROD_SNIPPET_LOCATION = "https://widget-client.hyro.ws/widget.js";

export const resolveEnvironmentSnippetLocation = environment =>
  ({
    [ENVIRONMENTS.DEVELOPMENT]: DEV_SNIPPET_LOCATION,
    [ENVIRONMENTS.LOCAL]: DEV_SNIPPET_LOCATION,
    [ENVIRONMENTS.BRANCH]: DEV_SNIPPET_LOCATION,
    [ENVIRONMENTS.PRODUCTION]: PROD_SNIPPET_LOCATION
  }[environment] ?? DEV_SNIPPET_LOCATION);

export const makeSnippet = ({
  assistantId,
  environmentUrl
}) => `<script>
    window.HYRO_WIDGET_ID = "${assistantId}";
    (function() {
      const f = function() {
        const d = document;
        const l = d.createElement('script');
        l.type = 'text/javascript';
        l.async = true;
        l.src = '${environmentUrl}?id=' + window.HYRO_WIDGET_ID;
        const x = d.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(l, x);
      };
      window.addEventListener('load', f, false);
    })();
  </script>`;

export const makeBranchDeployerSnippet =
// eslint-disable-next-line no-secrets/no-secrets
(assistantId, widgetServerUrl) => `<script>
    window.HYRO_WIDGET_SERVER_URL = "${widgetServerUrl.replace("https", "wss")}";
    window.HYRO_WIDGET_ID = "${assistantId}";
    (function() {
      const f = function() {
        const d = document;
        const l = d.createElement('script');
        l.type = 'text/javascript';
        l.async = true;
        l.src = '${DEV_SNIPPET_LOCATION}?id=' + window.HYRO_WIDGET_ID;
        const x = d.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(l, x);
      };
      window.addEventListener('load', f, false);
    })();
  </script>`;
